import { render, staticRenderFns } from "./UsersCard.vue?vue&type=template&id=46db1fef"
import script from "./UsersCard.vue?vue&type=script&lang=js"
export * from "./UsersCard.vue?vue&type=script&lang=js"
import style0 from "./UsersCard.vue?vue&type=style&index=0&id=46db1fef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports